'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var Toggleable = require('../alloy-toggleable/Toggleable.js');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');

var Accordion = function (_a) {
    var _b = _a.allowMultiple, allowMultiple = _b === void 0 ? false : _b, children = _a.children, activeChildren = _a.activeChildren, setActiveChildren = _a.setActiveChildren;
    var _c = useDefaultInternalState.default(activeChildren, setActiveChildren), active = _c[0], setActive = _c[1];
    return (jsxRuntime.jsx(Toggleable.default, tslib.__assign({ allowMultiple: allowMultiple, activeChildren: active, setActiveChildren: setActive }, { children: children })));
};
var Accordion$1 = Accordion;

exports.default = Accordion$1;
//# sourceMappingURL=Accordion.js.map
